const Services_Data = [
    {
        "s_no": "01",
        "s_name": "Platform Engineering",
        "s_desc": "Design and operate the internal platform that enables teams to ship faster. I architect multi-environment systems with Docker, Nginx, and VPS infrastructure, ensuring reliable and reproducible deployments across all environments."
    },
    {
        "s_no": "02",
        "s_name": "Product Development",
        "s_desc": "Build full-stack products from the ground up using React, Next.js, Node.js, and modern databases (MongoDB, PostgreSQL, Redis). I deliver production-ready applications with clean architecture and scalable data layers."
    },
    {
        "s_no": "03",
        "s_name": "CI/CD Pipeline Automation",
        "s_desc": "Design and implement automated build, test, and deploy pipelines on GitLab CI/CD using Kaniko for rootless Docker image builds, with environment-specific deployment stages and rollback strategies."
    },
    {
        "s_no": "04",
        "s_name": "DevSecOps",
        "s_desc": "Integrate security into the delivery pipeline — container vulnerability scanning with Trivy, secrets management with Infisical, and identity & access management with Keycloak. Security is not an afterthought."
    },
    {
        "s_no": "05",
        "s_name": "Infrastructure & Deployment",
        "s_desc": "Manage production infrastructure on VPS — Nginx reverse proxy, Docker Compose multi-service orchestration, SSH-based deployments with rsync, MinIO for object storage, and isolated multi-environment configuration."
    },
    {
        "s_no": "06",
        "s_name": "Monitoring & Observability",
        "s_desc": "Set up observability stacks with Prometheus for metrics collection and Grafana for dashboards. Track system health, service latency, resource usage, and pipeline metrics across all environments."
    }
]

export default Services_Data;
